import React, { useEffect, useState } from 'react'
import { ArrowRight, X } from 'lucide-react'
import ModalTest from '../../BaseModal'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ButtonContainer, Button, CloseDiv, ContainerOfModal, Header, HeaderTitle } from '../../styles/modal-style'
import { TwoColumnLayout, MainColumn, SideColumn, Section, SectionTitle, SidebarSection, SidebarSectionTitle, SidebarButton, InputComment } from './style'
import History from './History'
import Options from './Options'
import Status from './Status'
import SimpleData from './SimpleData'
import Actions from './Actions'
import CommentsOfOp from './Comments'
import axios from 'axios'
import SelectMaterials from './SelectMaterials'
import ShowServices from './SelectServices'
import LoadingComponent from '../../LoadingComponent'
import ConfirmModal from './ConfirmModal'
import AddServiceModal from './AddServiceModal'
import SplitOPModal from './SplitOPModal'
import GeneratePDFModal from './GeneratePDFModal'

enum ModalSection {
  ADD_SERVICE = 1,
  REVERT_OP = 2,
  SPLIT_OP = 3,
  GENERATE_PDF = 4
}

export interface OpViewerType {
  id: number
  codeOfOP: string
  lastStageId: number
  currentStageId: number
  status: number
  nextStageId: number
  integratedWithOmie: boolean
  orderItem: {
    id: number, 
    ploomesProductName: string
    length?: number
    diameter?: number
    thickness?: number
    width?: number
    weight?: number
    order:{originDealIdPloomes:number, saleNumberPloomes:number, orderItems:{id:number}[], integratedWithOmie:boolean},
    indexInOrder:number
  }
  stockInProduction: []
  service_stage?: {
    stageId: number
    index: number
    completed: boolean
  }[]
}

const ViewOPCard = () => {
  const navigate = useNavigate()
  const [ searchParams ] = useSearchParams()
  const id = searchParams.get('id')
  const [ isLoading, setIsLoading ] = useState<boolean>(true)
  const [ refresh, setRefresh ] = useState<boolean>(false)
  const [ modalActive, setModalActive ] = useState<number | null>(null)
  const [ serviceToEdit, setServiceToEdit ] = useState<any>(null)
  const [ op, setOp ] = useState<OpViewerType>({
    id: Number(id),
    codeOfOP: '',
    status: 0,
    currentStageId:0,
    lastStageId:0,
    nextStageId:0,
    orderItem: {id: 0, ploomesProductName: '', order:{originDealIdPloomes:0, saleNumberPloomes:0, orderItems:[{id:0}], integratedWithOmie:false}, indexInOrder:0},
    stockInProduction: [],
    integratedWithOmie: false,
  })

  useEffect(() => {
    if(modalActive === null) {
      axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/service/${id}`)
        .then(response => {
          if(response.data) {
            setOp(response.data)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [refresh, modalActive])
  
  const toolTip = op.orderItem && [
    op.orderItem.length ? `comp: ${op.orderItem.length}mm` : '',
    op.orderItem.diameter ? `dia: ${op.orderItem.diameter}mm` : '',
    op.orderItem.thickness ? `esp: ${op.orderItem.thickness}mm` : '',
    op.orderItem.width ? `larg: ${op.orderItem.width}mm` : '',
    op.orderItem.weight ? `peso: ${op.orderItem.weight}kg` : ''
  ].filter(Boolean).join(' | ')
  
  return (
    <ModalTest>
      <ContainerOfModal width='72rem'>
        <Header>
          <div>
            <Status status={op.status} />
            <HeaderTitle><h2>{op.codeOfOP}</h2> {toolTip && <span title={toolTip}>{op.orderItem.ploomesProductName}</span>}</HeaderTitle>
            {op.stockInProduction?.length > 0 && 
              <button
                style={{
                backgroundColor: '#fff',
                border: '1px solid #0090D3',
                color: '#0090D3', 
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
                marginTop: '1rem',
                marginRight: '1rem',
                }}
                onClick={() => setModalActive(ModalSection.REVERT_OP)}
              >
                REVERTER
              </button>
            }
            {!op.codeOfOP.includes('.') &&
              <button
                style={{
                backgroundColor: '#fff',
                border: '1px solid #0090D3',
                color: '#0090D3', 
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
                marginTop: '1rem',
                marginRight: '1rem',
                }}
                onClick={() => setModalActive(ModalSection.SPLIT_OP)}
              >
                DIVIDIR
              </button>
            }
            <button
              style={{
              backgroundColor: '#fff',
              border: '1px solid #0090D3',
              color: '#0090D3', 
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px',
              marginTop: '1rem',
              }}
              onClick={() => setModalActive(ModalSection.GENERATE_PDF)}
            >
              GERAR PDF
            </button>
          </div>
          <CloseDiv onClick={() => navigate('..')}> <X size={20} /></CloseDiv>
        </Header>
        <TwoColumnLayout>
          <MainColumn>
            <SelectMaterials stockInProduction={op.stockInProduction || []} integratedWithOmie={op.orderItem.order.integratedWithOmie} setIsLoading={setIsLoading} setRefresh={setRefresh}  />
            <ShowServices setModalActive={setModalActive} refresh={refresh} setRefresh={setRefresh} setServiceToEdit={setServiceToEdit} />
            {/* <SimpleData />
            <CommentsOfOp />
            <History /> */}
          </MainColumn>
          {/* <SideColumn>
            <Options />
            <Actions op={op} />
          </SideColumn> */}
        </TwoColumnLayout>
      </ContainerOfModal>
      {isLoading && <LoadingComponent />}
      {modalActive === ModalSection.REVERT_OP && <ConfirmModal setModalActive={setModalActive} id={op.id} setRefresh={setRefresh} />}
      {modalActive === ModalSection.ADD_SERVICE && <AddServiceModal setModalActive={setModalActive} id={op.id} setRefresh={setRefresh} serviceToEdit={serviceToEdit} setServiceToEdit={setServiceToEdit} />}
      {modalActive === ModalSection.SPLIT_OP && <SplitOPModal setModalActive={setModalActive} id={op.id} setRefresh={setRefresh} />}
      {modalActive === ModalSection.GENERATE_PDF && <GeneratePDFModal onClickClose={() => setModalActive(null)} />}
    </ModalTest>
  )
}

export default ViewOPCard